import type { Gtm } from '~~/types/@nuxtjs/gtm';

const noopGtm: Gtm = {
  push: () => {},
};

export const useGtmClient = (): Gtm => {

  const nuxtApp = useNuxtApp();

  return nuxtApp.$gtmClient || noopGtm;

};
